export const API_BASE_URL_V1 = '/api/v1';

export default {
    ANALYTICS: `${API_BASE_URL_V1}/analytics`,
    PROD_HOUSE: `${API_BASE_URL_V1}/production-houses`,
    FREELANCER: `${API_BASE_URL_V1}/freelancers`,
    MEMBERS: `${API_BASE_URL_V1}/members`,
}
